// Section 19: Poor harvest. 10% per season, Autumn bias. The harvest of the season it strikes is
// 0.6x. Foreshadowed the season before by "the crops look thin" 60% of the time (a warning can
// be false). Constants: config.events['poor-harvest'].
import type { Config } from '../../config';
import {
  effectDelta,
  effectParamModifiers,
  eventEntry,
  eventTurn,
} from '../../core/content-helpers';
import { defineEvent } from '../../core/registry';

export function poorHarvest(config: Config) {
  const c = config.events['poor-harvest'];
  return defineEvent({
    id: 'poor-harvest',
    label: 'Poor harvest',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['autumn'],
    foreshadow: { chance: c.foreshadowChance },
    ledgerTag: null,
    weight: () => c.baseChance,
    text: () => eventEntry('poor-harvest', { mul: c.harvestMul }),
    apply: (ctx) => [
      effectDelta('poor-harvest', 'harvest', eventTurn(ctx) + 1, 1, { harvestMul: c.harvestMul }),
    ],
    choices: [],
    modifierTargets: ['harvestYield'],
    modifiers: effectParamModifiers,
  });
}
